import { MutableRefObject } from 'react';

import { analyticsTypes } from '../types';

export const sortNewDialogs = (
  prevOrderRef: MutableRefObject<string[]>,
  stats?: analyticsTypes.NewDialogsStats
) => {
  const entries = Object.entries(stats?.data ?? {});
  entries.sort(([, a], [, b]) => b - a);

  return entries.map(([page, count], index) => {
    const prevIndex = prevOrderRef.current.indexOf(page);

    let indicator: '↑' | '↓' | null = null;

    if (prevIndex !== -1) {
      if (prevIndex > index) indicator = '↑';
      else if (prevIndex < index) indicator = '↓';
    }

    return { page, count, indicator };
  });
};
